import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { ArrowRight } from 'lucide-react';
import { useCompanyRequests } from '@/hooks/useCompanyRequests';

const AdminBanner = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Hämtar företagsförfrågningar
  const { data: requests = [] } = useCompanyRequests();
  const unhandledCount = requests.filter(r => r.status !== 'handled').length;

  // Visa inte laddning eller ifall man inte är inloggad
  if (loading || !user) return null;
  
  // Dölj bannern om man redan befinner sig på Inloggning eller nån av Personalsidorna
  if (location.pathname.startsWith('/personal') || location.pathname === '/login') return null;

  return (
    <div className="bg-slate-900 text-slate-100 text-sm py-2 px-4 flex justify-between items-center z-[100] sticky top-0 shadow-sm animate-fade-in">
      <div className="flex items-center gap-2">
        <span className="font-semibold hidden sm:inline">Inloggad som personal</span>
        <span className="opacity-90">({user.email})</span>
      </div>
      <div className="flex items-center gap-3">
        {unhandledCount > 0 && (
          <Link to="/personal/forfragningar" className="hidden sm:flex items-center gap-1.5 text-xs text-destructive-foreground bg-destructive hover:bg-destructive/90 px-2 py-1 rounded transition-colors font-medium">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
            {unhandledCount} nya förfrågningar
          </Link>
        )}
        <Link 
          to="/personal/meny" 
          className="flex items-center gap-1.5 hover:bg-primary/90 bg-primary text-primary-foreground px-3 py-1.5 rounded transition-colors font-medium text-xs"
        >
          Till Personalvy
          <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
};

export default AdminBanner;
